<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cv8skz/tc-custom/9781452129631.jpg?1704761351254" alt="This image is the cover for the book Giving Thanks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Giving Thanks
      </h1>
      <p class="bookDescription body article font2">
        <b>A beautifully illustrated collection celebrating the joy of gratitude: “A book to be picked up throughout the year and savored and discussed.” —<i>Booklist</i> (starred review)</b><br/><br/>Newbery Medal winner Katherine Paterson and cut-paper artist Pamela Dalton, creators of <i>Brother Sun, Sister Moon</i>, give fans of all ages even more to be thankful for with <i>Giving Thanks</i>, a special book about gratitude. <br/><br/>Paterson’s meditations on what it means to be truly grateful and Dalton’s exquisite cut-paper illustrations are paired with a collection of over fifty graces, poems, and praise songs from a wide range of cultures, religions, and voices. The unique collaboration between these two extraordinary artists flowers in this important and stunningly beautiful reflection on the act of giving thanks.<br/><br/>“A joyfulness of spirit permeates the compilation.” —<i>Publishers Weekly</i> (starred review)<br/><br/>“Amen.” —<i>Kirkus Reviews</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Paterson, Pamela Dalton
      </h2>
      
      <p class="authorDescription body article">Katherine Paterson is a two-time Newbery Medal winner and a two-time National Book Award winner. She lives in Barre, Vermont.Pamela Dalton is a master of scherenschnitte, the art of paper-cutting. Her artwork has enthralled collectors worldwide for more than two decades. She lives in Harlemville, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ba446c0